// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.msg-threads-list-container * {
  font-weight: bold;
}
.msg-threads-list-container .msg-thread-item-list {
  padding: 0;
  overflow-y: auto;
  overflow-x: hidden;
}
.msg-threads-list-container .msg-thread-item-list .msg-thread-activ {
  background-color: rgba(0, 0, 0, 0.12);
  border-bottom: none !important;
}
.msg-threads-list-container .msg-thread-item-list .msg-thread-unviewed-msg {
  width: 15px;
  height: 15px;
  background-color: red;
  border-radius: 50%;
}
.msg-threads-list-container .msg-thread-item-list .msg-thread-item {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  padding: 10px;
}
.msg-threads-list-container .msg-thread-item-list .msg-thread-item .msg-thread-item-ico {
  width: 40px !important;
  min-width: 40px !important;
  height: 40px !important;
  min-height: 40px !important;
  line-height: 55px;
  text-align: center;
  border-radius: 50%;
  background-color: #24b7c7;
}
.msg-threads-list-container .msg-thread-item-list .msg-thread-item .msg-thread-item-ico .mat-icon svg path {
  fill: white !important;
}
.msg-threads-list-container .msg-thread-item-list .msg-thread-item .msg-thread-item-particpants {
  text-align: center;
  cursor: pointer;
}
.msg-threads-list-container .msg-thread-item-list .msg-thread-item .msg-thread-item-particpants div {
  font-weight: bold;
  margin-left: 5px;
}
.msg-threads-list-container .msg-thread-btn-bar {
  background-color: rgba(0, 0, 0, 0.04);
  padding: 8px;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  min-height: 68px;
}`, "",{"version":3,"sources":["webpack://./src/app/@modules/messaging/core/components/messaging-list/messaging-list.component.scss"],"names":[],"mappings":"AAOI;EACI,iBAAA;AANR;AASI;EAEI,UAAA;EACA,gBAAA;EACA,kBAAA;AARR;AAUQ;EACI,qCAAA;EACA,8BAAA;AARZ;AAWQ;EACI,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;AATZ;AAYQ;EAEI,4CAAA;EACA,aAAA;AAXZ;AAaY;EAEI,sBAAA;EACA,0BAAA;EACA,uBAAA;EACA,2BAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBA3CE;AA+BlB;AAcgB;EACI,sBAAA;AAZpB;AAiBY;EACI,kBAAA;EACA,eAAA;AAfhB;AAiBgB;EACI,iBAAA;EACA,gBAAA;AAfpB;AAuBI;EACI,qCAAA;EACA,YAAA;EACA,yCAAA;EACA,gBAAA;AArBR","sourcesContent":["$validated-color: #24b7c7; \n$warning-color: #ED6723;\n$success-color: #679A00;\n$error-color:  darkred;\n\n.msg-threads-list-container {\n\n    * {\n        font-weight: bold;\n    }\n\n    .msg-thread-item-list {\n\n        padding: 0;\n        overflow-y: auto;\n        overflow-x: hidden;\n\n        .msg-thread-activ {\n            background-color: rgba(0, 0, 0, 0.12);\n            border-bottom: none !important;\n        }\n\n        .msg-thread-unviewed-msg {\n            width: 15px;\n            height: 15px;\n            background-color: red;\n            border-radius: 50%;\n        }\n\n        .msg-thread-item {\n\n            border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n            padding: 10px;\n\n            .msg-thread-item-ico {\n\n                width: 40px !important;\n                min-width: 40px !important;\n                height: 40px !important;\n                min-height: 40px !important;\n                line-height: 55px;\n                text-align: center;\n                border-radius: 50%;\n                background-color: $validated-color;\n \n                .mat-icon svg path {\n                    fill: white !important;\n                }\n\n            }\n\n            .msg-thread-item-particpants {\n                text-align: center;\n                cursor: pointer;\n\n                div {\n                    font-weight: bold;\n                    margin-left: 5px;\n                }\n            }\n\n        }\n\n    }\n\n    .msg-thread-btn-bar {\n        background-color: rgba(0, 0, 0, 0.04); \n        padding: 8px; \n        border-top: 1px solid rgba(0, 0, 0, 0.12);\n        min-height: 68px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
